import { ICourseCard } from 'models/courseCard.model'
import { IEnrolCard } from 'models/enrolCard.model'
import api from '..'

interface IViewAllCoursesParams {
  folder?: string
  advance?: number
  page: number
  q?: any
}

export interface ViewAllCourse {
  id: string
  type: string
  attributes: {
    course: ICourseCard
    enrol: IEnrolCard
  }
}

const ViewAllCourses = (params: IViewAllCoursesParams) => {
  return api
    .post<{ data: ViewAllCourse[] }>('/courses/search', params)
    .then(({ data, headers }) => ({
      courses: data.data.map(({ attributes }) => attributes),
      total: +headers['total'],
      perPage: +headers['per-page'],
    }))
}

export default ViewAllCourses
